
import { Component, Prop, Watch } from 'vue-property-decorator'
import { convertCurrency } from '~/utility/convertCurrency'
import { formatPrice } from '~/utility/formatCurrency'
import { getPointFromStringOrDefault } from '~/utility/geo/latLng'
import { SimpleMoney, priceToMoneyType } from '~/utility/money'
import { MapCampsite } from '../../domain/MapsCampsite'
import { PuMapProps } from '../pu-map/PuMapProps'
import { IconMarker, Marker, MarkerType, PriceMarker } from '../pu-map/types'
import CampsitesMapBase from './CampsitesMapBase'
import { CampsitesMapProps } from './CampsitesMapProps'

@Component
export default class CampsitesMap
  extends CampsitesMapBase
  implements CampsitesMapProps
{
  @Prop({ required: true })
    campsites: MapCampsite[]

  @Prop({ default: MarkerType.icon })
    markersType: MarkerType

  markers: Marker[] = []
  markersGenerated: boolean = false

  created() {
    this.regenerateMarkers()
  }

  @Watch('campsites')
  regenerateMarkers() {
    void this.generateMarkers().then((markers) => {
      this.markers = markers
      this.markersGenerated = true
    })
  }

  // this is because price is async
  generateMarkers() {
    return Promise.all(
      this.campsites.map(async (campsite) => {
        return !campsite.price || this.markersType === MarkerType.icon
          ? Promise.resolve(this.getIconMarker(campsite))
          : await this.getPriceMarker(campsite)
      }),
    )
  }

  private getMarkerBase(campsite: MapCampsite) {
    const { lat, lng } = getPointFromStringOrDefault(campsite.point)
    return {
      campsiteId: campsite.id,
      data: campsite,
      name: campsite.name,
      position: { lat, lng },
      slug: campsite.slug,
    }
  }

  private getIconMarker(campsite: MapCampsite): IconMarker {
    return {
      ...this.getMarkerBase(campsite),
      type: MarkerType.icon,
    }
  }

  private async getPriceMarker(campsite: MapCampsite): Promise<PriceMarker> {
    const convertedPrice = await convertCurrency(
      priceToMoneyType(campsite.price as SimpleMoney),
      this.$i18n.current.currency,
    )
    return {
      ...this.getMarkerBase(campsite),
      type: MarkerType.price,
      price: formatPrice(convertedPrice, this.$i18n.locale),
    }
  }

  get puMapProps(): PuMapProps {
    return {
      initialZoom: this.initialZoom,
      centre: this.centre || this.markers[0]?.position,
      markers: this.markers,
      initialBounds: this.initialBounds,
      circle: this.circle,
      visibleMarker: this.visibleMarker,
      useClustering: this.useClustering,
      zoomControl: this.zoomControl,
    }
  }
}
